import * as React from "react";
import { RotatingLines } from "react-loader-spinner";
import styles from "./styles.module.css";

const Loader = () => {
  return (
    <div className={styles.loader}>
      <RotatingLines width="50" />
      <p>Loading....</p>
    </div>
  );
};

export default Loader;
